import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHigh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="High"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#DC362E"
      d="M3.3 4.356c0-.802.519-1.51 1.283-1.754a6.44 6.44 0 0 1 4.568.254l.809.36a6.76 6.76 0 0 0 4.372.386 1.932 1.932 0 0 1 2.396 1.876V8.91a2.423 2.423 0 0 1-2.127 2.405l-.479.06a6.87 6.87 0 0 1-3.887-.66l-.737-.365a5.07 5.07 0 0 0-4.194-.134A1.447 1.447 0 0 1 3.3 8.881zm.61 13.374a.61.61 0 0 0 .61-.61v-4.883a.61.61 0 1 0-1.22 0v4.883c0 .337.273.61.61.61"
    />
  </svg>
);
export default SvgHigh;
